import { render, staticRenderFns } from "./ListDataLoadingWidget.vue?vue&type=template&id=125204d4&scoped=true&"
import script from "./ListDataLoadingWidget.vue?vue&type=script&lang=js&"
export * from "./ListDataLoadingWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125204d4",
  null
  
)

export default component.exports